import {useMemo, useState} from 'react';
import {useWindowDimensions, Modal, View, StyleSheet} from 'react-native';
import {ModalContext, ModalOptions} from 'extensions/viewport/ModalContext';
import {theme} from 'config/themes';

export const ModalProvider = ({children}) => {
  const screen = useWindowDimensions();
  const [content, setContent] = useState<JSX.Element>();
  const [options, setOptions] = useState<ModalOptions>({});
  const [visible, setVisible] = useState<boolean>(false);
  const classes = {
    root: [
      !options.frameless ? styles.root : styles.noframe,
      options.frameless ? styles.noframe : styles.root,
      options.overlay && styles.overlay,
    ],
    content: [
      options.frameless ? styles.noframe : styles.content,
      screen.width < 500 && styles.contentSmall,
    ],
  };

  const context = useMemo(() => ({
    visible: false,
    open: (content: JSX.Element, options?: ModalOptions) => {
      setOptions(options ?? {});
      setContent(content);
      setVisible(true);
    },
    exit: () => {
      setVisible(false);
      setOptions({});
    },
  }), []);

  return (
    <ModalContext.Provider value={context}>
      {children}
      <Modal
        transparent
        visible={visible}
        style={options.style}
        onDismiss={!options.forceChoice ? context.exit : undefined}>
        <View style={classes.root} onPointerDown={() => !options.forceChoice && setVisible(false)}>
          <View style={classes.content} onPointerDown={(e) => e.stopPropagation()}>
            {content}
          </View>
        </View>
      </Modal>
    </ModalContext.Provider>
  )
}

const styles = StyleSheet.create({
  root: {
    flex: 1,
    alignItems: 'center',
    alignContent: 'center',
    justifyContent: 'center',
    backgroundColor: theme.dialog.overlay,
  },
  content: {
    minWidth: 360,
    maxWidth: 480,
    minHeight: 225,
    borderWidth: 1,
    borderColor: theme.dialog.border,
    backgroundColor: theme.dialog.input.fill,
  },
  contentSmall: {
    minWidth: 300,
  },
  noframe: {
    flex: 1,
  },
  overlay: {
    backgroundColor: theme.dialog.overlay,
  },
});

